import React from "react"
import { Button, Header, Modal, Icon } from "semantic-ui-react"

const MyModal = ({ submitModalIsOpen, toggleSubmitModal, finalSave }) => {
  return (
    <Modal open={submitModalIsOpen} onClose={toggleSubmitModal}>
      <Header icon="exclamation" content="Προσοχή" />
      <Modal.Content>
        <p>Έχετε επιλέξει οριστική αποθήκευση</p>
        <div>
          Εάν συνεχίσετε:
          <ul>
            <li> H δήλωσή σας θα καταχωρηθεί οριστικά στο σύστημα</li>
            <li> Δε θα μπορείτε να κάνετε περεταίρω τροποποιήσεις</li>
            <li> Θα μπορείτε να εκτυπώσετε τη δήλωσή σας</li>
          </ul>
        </div>
      </Modal.Content>
      <Modal.Actions>
        <Button floated="left" primary onClick={toggleSubmitModal}>
          <Icon name="arrow left" /> Επιστροφή στη φόρμα
        </Button>
        <Button positive onClick={finalSave}>
          <Icon name="check" /> Οριστική αποθήκευση
        </Button>
      </Modal.Actions>
    </Modal>
  )
}

export default MyModal
